import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'
import store from '@/store'
import PubNub from 'pubnub'

export default {
  resetChannels({ commit }, data) {
    commit(types.RESET_CHANNELS, data)
  },
  resetChannelInfo({ commit }) {
    commit(types.RESET_CHANNELINFO)
  },
  resetMessages({ commit }) {
    commit(types.RESET_MESSAGES)
  },
  quitChat({ commit }) {
    commit(types.RESET_PUBNUB)
  },
  setMembership({ commit }, membership) {
    commit(types.SET_MEMBERSHIP, membership)
  },
  setChatBar({ commit }, data) {
    commit(types.SET_CHATBAR, data)
  },
  // INIT CHAT
  async initChat({ state, commit }, data) {
    // initialize Chat (send along user's UUID)
    let profile = store.getters['auth/profile']
    let pubnub = new PubNub({
      publishKey: window.config ? window.config.pubnubPublishKey : '',
      subscribeKey: window.config ? window.config.pubnubSubscribeKey : '',
      uuid: profile.guid
    })
    // maintain state of pubnub service
    commit(types.SET_PUBNUB, {
      pubnub: pubnub
    })
    // get baseline timestamp
    let timestamp = await pubnub.time()
    commit(types.SET_PUBNUB_TIMESTAMP, timestamp.timetoken)
    // get unread count
    // console.log('Chat (initChat): get Unread')
    await commit(types.GET_UNREAD)
  },
  // GET CHAT CHANNELS
  async getChannels({ commit, state, dispatch }) {
    // get the channels from our API services
    let profile = store.getters['auth/profile']
    const r = await startLoading(dispatch, 'getChannels', () =>
      http.get(`chat/channels?firm=${profile.firm}`)
    )
    // set channels
    commit(types.SET_CHANNELS, r.data)
    return r.data
  },
  // GET CHAT CHANNEL INFO
  async getChannelInfo({ commit, state }, data) {
    // fetch the channel members
    let profile = store.getters['auth/profile']
    let result = await state.pubnub.objects.setChannelMembers({
      channel: data.calibrateEvent,
      uuids: [profile.guid]
    })
    console.log('Chat (getChannelInfo): fetch Members', result)
    let info = await state.pubnub.objects.getChannelMembers({
      channel: data.calibrateEvent,
      include: {
        UUIDFields: true
      }
    })
    // get channel info and set presence (i.e., hereNow)
    // console.log('Chat (getChannelInfo): set Channel & Presence')
    await commit(types.SET_CHANNELINFO, {
      data: data,
      info: info
    })
    return state.channelInfo
  },
  // GET CHANNEL MESSAGES
  async getChannelMessages({ commit, state }, data) {
    // get the channel messages
    // console.log('Chat (getChannelMessages): fetch Messages', data)
    let messages = null
    let start = null
    let results = await state.pubnub.fetchMessages({
      channels: [data.channelId],
      stringifiedTimeToken: true,
      // includeMeta: true,
      includeMessageActions: true,
      count: 100
    })
    let more = false
    if (results) {
      // console.log('Chat (getChannelMessages) first:', results)
      if (results.channels[data.channelId]) {
        messages = JSON.parse(JSON.stringify(results.channels[data.channelId]))
        if (results.more) {
          if (messages.length < results.more.max) {
            more = true
            start = results.more.start
          }
        }
      }
      let cnt = 30
      while (more || cnt <= 0) {
        more = false
        cnt--
        let moreResults = await state.pubnub.fetchMessages({
          channels: [data.channelId],
          stringifiedTimeToken: true,
          // includeMeta: true,
          includeMessageActions: true,
          start: start,
          count: 100
        })
        if (moreResults) {
          // console.log('Chat (getChannelMessages) next:', moreResults)
          // prepend array
          let moreMessages = JSON.parse(JSON.stringify(moreResults.channels[data.channelId]))
          messages = [...moreMessages, ...messages]
          if (moreResults.more) {
            more = true
            start = moreResults.more.start
          }
        }
      }
    }
    commit(types.SET_MESSAGES, {
      id: data.channelId,
      messages: messages,
      isAdmin: data.isAdmin
    })
    // set this channel membership as messages read
    let timestamp = await state.pubnub.time()
    console.log('Chat (getChannelMessages): set Membership')
    await state.pubnub.objects.setMemberships({
      channels: [
        {
          id: data.channelId.toString(),
          custom: {
            lastReadTimetoken: timestamp.timetoken
          }
        }
      ],
      include: {
        channelFields: true
      }
    })
    // then, get latest message count
    // console.log('Chat (getChannelMessages): get Unread')
    await commit(types.GET_UNREAD)
    return messages
  },
  // SEND A CHAT MESSAGE
  async sendMessage({ commit, state }, message) {
    // send the message
    console.log('Chat: sending Message', message)
    const result = await state.pubnub.publish({
      message: message.message,
      channel: message.channelId,
      sendByPost: true,
      storeInHistory: true,
      meta: null
    })
    // set this channel membership as messages read
    // console.log('Chat (sendMessage): update Channel Membership')
    let timestamp = await state.pubnub.time()
    await state.pubnub.objects.setMemberships({
      channels: [
        {
          id: message.channelId.toString(),
          custom: {
            lastReadTimetoken: timestamp.timetoken
          }
        }
      ],
      include: {
        channelFields: true
      }
    })
    return result
  },
  // SET MESSAGE
  async setMessage({ commit, state }, message) {
    console.log('Chat (setMessage): setting...', {
      message: message,
      channel: state.channelInfo
    })
    commit(types.SET_MESSAGE, message)
    let proceed = true
    if (state.channelInfo) {
      if (state.channelInfo.id.toString() === message.channel) {
        proceed = false
      }
    }
    if (proceed) {
      // console.log('Chat (setMessage): get Unread')
      await commit(types.GET_UNREAD)
    }
  },
  // SET UNREAD
  setUnread({ commit }, counts) {
    commit(types.SET_UNREAD, counts)
  },
  // MEMBER IS TYPING
  memberTyping({ commit, state }, data) {
    console.log('Chat (memberTyping):', data)
    state.pubnub.signal(
      {
        message: data.status,
        channel: data.channel
      },
      (status, response) => {
        console.log('Chat (memberTyping response):', {
          status: status,
          response: response
        })
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/actions.js